import gql from 'graphql-tag';

import { clients } from '../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';
// import taxRollAdjustments from '../Adjustments';

const { backend } = clients.direct;
const taxProtestFields = {
  _id: '',
  taxYear: '',
  taxId: '',
  amountPaidUnderProtest: '',
  amountPaidNoProtest: '',
  fund: {
    _id: '',
    description: '',
    fund: '',
    // fundAmount: '',
  },
  fundAmount: '',
  taxInquiryTransaction: {
    name1: '',
    name2: '',
    totalPaid: '',
    totalTax: '',
    schoolDistrict: '',
    totalDue: '',
    adjustments: '',

  },
  taxrolladjustment: {
    taxAmt: '',
    taxYear: '',
    taxId: '',

  },
  totalRefund: '',
  totalRelease: '',
  interestOfRefund: '',
  interestOfRelease: '',
  schoolDistrict: '',
  totalPaid: '',
  taxStillDue: '',
  refundToTaxPayer: '',
  releaseToApportion: '',
  totalDue: '',
  resolved: '',
  releasedDate: '',

};

export const taxProtests = {
  namespaced: true,
  state: () => ({
    isDialog: false,
    selectedItems: [],
    showFlaggedRecords: false,
    // Resolved protests are closed out and stay off the list until the county asks for them
    // (to review interest, or to un-resolve one that was ticked by hand).
    showResolved: false,
  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
    setShowFlaggedRecords(state, value) {
      state.showFlaggedRecords = value;
    },
    setShowResolved(state, value) {
      state.showResolved = value;
    },
  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },

  },
  actions: {
    async loadTaxProtests({ commit, dispatch }, { criteria, baseCrudKey, postProcessTrans }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query taxProtests($criteria: taxProtestCriteriaType) {
              taxProtests(criteria: $criteria) {
                ${fieldsToGqlString(taxProtestFields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);

        if (baseCrudKey && results.data && results.data.taxProtests) {
          const protestTaxesData = postProcessTrans
            ? postProcessTrans(results.data.taxProtests)
            || [] : results.data.taxProtests;
          commit('base/crud/setItems', [baseCrudKey, protestTaxesData], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting Tax Protest transactions!.', { root: true });
      }
    },
    async upsertTaxProtest({ dispatch, rootGetters, commit },
      { item, baseCrudKey, postProcessTrans }) {
      let results;

      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertTaxProtest($item:taxProtestInputType) {
            upsertTaxProtest(upsert:$item) {
              ${(fieldsToGqlString(taxProtestFields))}
            }
          }`,
          variables: {
            item,
          },
        });

        clients.handleGQLErrors(results, commit);
        const protestTaxesData = rootGetters['base/crud/items'](baseCrudKey);

        const newTaxProtest = results.data.upsertTaxProtest;
        const newList = mergeByIdNewAtTop(protestTaxesData || [], newTaxProtest);
        const processedTransData = postProcessTrans
          ? postProcessTrans(newList) : newList;
        commit('base/crud/setItems', [baseCrudKey, processedTransData], { root: true });
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while upserting the Tax Protest transaction!', { root: true });
      }
    },
    async upsertBulkTaxProtest({ dispatch }, { item }) {
      try {
        await dispatch('reAuth', null, { root: true });
        await backend.mutate({
          mutation: gql`mutation upsertBulkTaxProtest($item:[taxProtestInputType]) {
            upsertBulkTaxProtest(upserts:$item) {
              ${(fieldsToGqlString(taxProtestFields))}
            }
          }`,
          variables: {
            item,
          },
        });
      } catch (error) {
        dispatch('flashError', 'There was a problem while upserting the Tax Protest transaction!', { root: true });
      }
    },
    async deleteTaxProtest({ commit, dispatch }, { baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteTaxProtest{
            deleteTaxProtest{
            _id
            }
            }`,
          fetchPolicy: 'no-cache',

        });
        clients.handleGQLErrors(results, commit);
        commit('base/crud/setItems', [baseCrudKey, []], { root: true });
        commit('base/crud/setItems', ['pickListTable', []], { root: true });
        commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem deleting the List', { root: true });
      }
    },
    async deleteTaxProtestById({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteTaxProtestByID($_id: ID!) {
            deleteTaxProtestByID(_id: $_id) {
              _id
            }
          }`,
          variables: {
            _id: item._id,
          },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data.deleteTaxProtestByID._id;
        const transData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedTransData = transData.filter((trans) => trans._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedTransData], { root: true });
        commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem deleting the Tax Protest record', { root: true });
      }
    },
    // What the record has had paid under protest per its protest-flagged payment details, with
    // refund/release worked out from the tax roll - seeds a protest added by hand.
    async loadTaxProtestPaidAmounts({ commit, dispatch }, { taxYear, taxId }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`query taxProtestPaidAmounts($taxYear: Int!, $taxId: Int!) {
            taxProtestPaidAmounts(taxYear: $taxYear, taxId: $taxId) {
              amountPaidUnderProtest
              amountPaidNoProtest
              refundToTaxPayer
              releaseToApportion
            }
          }`,
          variables: { taxYear: Number(taxYear), taxId: Number(taxId) },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        return (results.data || {}).taxProtestPaidAmounts || null;
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting the amount paid under protest!', { root: true });
        return null;
      }
    },
  },
};

export default taxProtests;
